export const SUCCESS_PAYMENT_TRANSACTION_MESSAGE: string = 'payment.success_message';
export const COPIED_MASSAGE: string = 'copied_message';
